import React from 'react';
import $ from 'jquery';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import Pagination from 'react-js-pagination';
import ReactToPrint from 'react-to-print';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import advanceFilter from "LIBRARY/CommonResources/images/advanceFilter.svg";
import { toast } from 'react-toastify';
import Select from 'react-select';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';


let resourceTypeData = [
    "Text Book",
    "Reference Book",
    "Atlas",
    "Biography",
    "Book with CD",
    "CD-ROM",
    "Floppy",
    "General",
    "Laboratory Manual",
    "Practical",
    "Practical Manual",
    " Practical Note Book",
    "Text Book(Practical)",
    "Text Book(Theory & Practical)",
    "Question Bank",
    "Project Thesis",
    "Other",
    "Book bank",
    "Bound Volume",
    "Current issue of the journals",
    "Syllabus copy",
    "Previous years question papers copy"
];

let resourceStatusData = [
    {
        label: 'All',
        value: 'All'
    },
    {
        label: 'Missing',
        value: 'Missing'
    },
    {
        label: 'Discarded',
        value: 'Discarded'
    },
    {
        label: 'Available',
        value: 'Available'
    },
    {
        label: 'Maintenance (Binding)',
        value: 'binding'
    }
];

class ResourceTitleReport extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All resource list as per accession series
            resourceListLoading: false,
            totalResourceListItems: 0,
            resourceList: {},
            pageIndex: 1,
            limit: "10",

            // report filter
            searchByTitle: '',
            searchByAuthor: '',
            searchByAccessionNumber: '',
            searchByInvoiceNumber: [],
            searchByAccessionSeries: [],
            searchByDepartment: [],
            searchByResourceCategory: [],
            searchByLocation: [],
            searchByResourceType: [],
            searchByResourceStatus: {
                "value": "All",
                "label": "All"
            },
            isDonated: false,
            billFromDate: '',
            billToDate: '',

            GetInvoiceDataList: {},
            loadingInvoiceData: false,
            accessionSeriesList: {},
            loadingAccessionSeries: false,
            GetStreamList: {},
            loadingStreamData: false,
            GetResourceCategoryList: {},
            loadingResourceCategoryData: false,
            GetLocationList: {},
            loadingLocationData: false,
            GetResourceStatusList: {},
            loadingResourceStatusData: false,
            GetMultipleAccessionNumberList: {},
            loadingAccessionNumberData: false,

            //filter button 
            showFilterModal: false,

            // custom list column
            selectAll: true,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Title", isVisible: true },
                { name: "Author", isVisible: true },
                { name: "Resource Volume", isVisible: true },
                { name: "Resource Edition", isVisible: true },
                { name: "Resource Language", isVisible: true },
                { name: "Publisher", isVisible: true },
                { name: "Number of copies", isVisible: true },
                { name: "Number of Pages", isVisible: true },
                { name: "Number of Preliminary Pages", isVisible: true },

                { name: "Year of Publication", isVisible: true },
                { name: "Resource Type", isVisible: true },
                { name: "Translated", isVisible: true },
                { name: "Resource Condition", isVisible: true },
                { name: "Price", isVisible: true },
                { name: "Donated", isVisible: true },
                { name: "Resource Status", isVisible: true }
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Title", key: 'title' },
                { name: "Author", key: 'author' },
                { name: "Resource Volume", key: 'resourceVolume' },
                { name: "Resource Edition", key: 'resourceEdition' },
                { name: "Resource Language", key: 'resourceLanguage' },
                { name: "Publisher", key: 'publisher' },
                { name: "Number of copies", key: 'numberOfCopies' },
                { name: "Number of Pages", key: 'numberOfPages' },
                { name: "Number of Preliminary Pages", key: 'numberOfPreliminaryPages' },

                { name: "Year of Publication", key: 'yearOfPublication' },
                { name: "Resource Type", key: 'resourceType' },
                { name: "Translated", key: 'translated' },
                { name: "Resource Condition", key: 'resourceCondition' },
                { name: "Price", key: 'price' },
                { name: "Donated", key: 'donated' },
                { name: "Resource Status", key: 'resourceStatus' }
            ],

            exportItemVisibility: [
                { name: "Title", isVisible: true },
                { name: "Author", isVisible: true },
                { name: "Resource Volume", isVisible: true },
                { name: "Resource Edition", isVisible: true },
                { name: "Resource Language", isVisible: true },
                { name: "Publisher", isVisible: true },
                { name: "Number of copies", isVisible: true },
                { name: "Number of Pages", isVisible: true },
                { name: "Number of Preliminary Pages", isVisible: true },

                { name: "Year of Publication", isVisible: true },
                { name: "Resource Type", isVisible: true },
                { name: "Translated", isVisible: true },
                { name: "Resource Condition", isVisible: true },
                { name: "Price", isVisible: true },
                { name: "Donated", isVisible: true },
                { name: "Resource Status", isVisible: true }
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: [],
            allSortedIdArray: [],
            sortedIdArray: [],

            // total count
            priceTotalCount: 0,
            noOfCopiesTotalCount: 0,

            //advance filter modal
            advanceFilterModal: false,
        };
    }

    componentDidMount() {
        this.GetLibraryResourceListForTitleReport();  // report list
        this.getLibraryInvoiceListDataStatus();  // invoice data
        this.apiCallToGetAccessionSeries(); // accession series
        this.apiCallToGetInstituteStreamList();  // department
        this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
        this.GetLibraryLocationList();  // location list
        this.getLibraryResourceStatus();  // resource status
        this.formatCSVExportData('onLoad'); // export data
    }

    //API CALL METHOD TO LIST OF REPORT
    GetLibraryResourceListForTitleReport = async () => {
        this.setState({
            resourceListLoading: true
        });

        let requestData = {
            'iid': config.institute_id,
            'pageIndex': this.state.pageIndex,
            'limitPerPage': this.state.limit,
            'resource_status': 'all',
            'OnlyParentResources': 'true'
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceListForTitleReport',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceListForTitleReport()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        // Use reduce to accumulate totals
                        const totals = Object.values(apiResult.data).reduce((accumulator, resource) => {
                            const keyNoOfCopies = resource.copiesdetails || 0;
                            const keyPrice = resource.price || 0;

                            // Accumulate totals
                            accumulator.totalPrice += parseInt(keyPrice);
                            accumulator.totalNoOfCopies += (parseInt(keyNoOfCopies));
                            return accumulator;
                        }, {
                            totalPrice: 0,
                            totalNoOfCopies: 0,
                        });

                        this.setState({
                            resourceList: apiResult.data,
                            totalResourceListItems: apiResult?.resource_count,
                            priceTotalCount: totals.totalPrice,
                            noOfCopiesTotalCount: totals.totalNoOfCopies,
                            resourceListLoading: false
                        });
                    } else {
                        this.setState({
                            resourceList: {},
                            totalResourceListItems: 0,
                            priceTotalCount: 0,
                            noOfCopiesTotalCount: 0,
                            resourceListLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        resourceList: {},
                        totalResourceListItems: 0,
                        resourceListLoading: false
                    });
                }
            }
        }
    }

    // API CALL TO GET get invoice List 
    getLibraryInvoiceListDataStatus = async () => {
        this.setState({
            loadingInvoiceData: true,
        })
        let requestData = {
            iid: config.institute_id,
            pageIndex: "all",
            limitPerPage: "all",
            linkedTo: "library"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getTransactionListBasedOnLinkedTo',
            requestData,
            "/api/instructor/accountingManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getLibraryInvoiceListDataStatus();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    label: seriesData?.billno, // Display billno
                }));

                this.setState({
                    GetInvoiceDataList: formattedData,
                    loadingInvoiceData: false,
                })
            } else {
                this.setState({
                    loadingInvoiceData: false,
                })
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    apiCallToGetAccessionSeries = async () => {
        this.setState({ loadingAccessionSeries: true });

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(seriesId => {
                        apiResult[seriesId]['seriesId'] = seriesId;
                    });
                }

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesData.seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                }));

                this.setState({
                    accessionSeriesList: formattedMembers,
                    loadingAccessionSeries: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingAccessionSeries: false
                });
            }
        }
    }

    // API CALL TO GET get Institute Stream List 
    apiCallToGetInstituteStreamList = async () => {
        this.setState({
            loadingStreamData: true,
        })
        let requestData = {
            "iid": config.institute_id,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getInstituteStreamList',
            requestData,
            "/api/instructor/facultyRegistration.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetStreamList: apiResult.streamData,
                    loadingStreamData: false,
                })
            } else {
                this.setState({
                    loadingStreamData: false,
                })
            }
        }
    }

    // API CALL TO GET get resource category List 
    GetLibraryResourceCategoryListWithBasicDetails = async () => {
        this.setState({
            loadingResourceCategoryData: true,
        })
        let requestData = {
            iid: config.institute_id,
            isSortByAscendingCategoryName: "true"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceCategoryListWithBasicDetails',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceCategoryListWithBasicDetails();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const subCategories = [];

                    // If there are subCategories, iterate through them
                    if (Object.values(seriesData.subresource).length > 0) {
                        Object.entries(seriesData.subresource).forEach(([subCategoryId, subCategoryData]) => {
                            subCategories.push({
                                subCategoryId: subCategoryId,
                                subCategoryName: subCategoryData.name,
                                parentId: subCategoryData.parentCategoryId
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        subCategories: subCategories // Add subresource data (if any)
                    };
                });


                this.setState({
                    GetResourceCategoryList: formattedData,
                    loadingResourceCategoryData: false,
                })
            } else {
                this.setState({
                    loadingResourceCategoryData: false,
                })
            }
        }
    }

    // API CALL TO GET get location List 
    GetLibraryLocationList = async () => {
        this.setState({
            loadingLocationData: true,
        })
        let requestData = {
            iid: config.institute_id,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryLocationList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryLocationList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const sublocations = [];

                    // If there are sublocations, iterate through them
                    if (seriesData.subLocationCount > 0) {
                        Object.entries(seriesData.sublocation).forEach(([sublocationId, sublocationData]) => {
                            sublocations.push({
                                sublocationId: sublocationId,
                                sublocationName: sublocationData.name
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        sublocations: sublocations // Add sublocation data (if any)
                    };
                });

                this.setState({
                    GetLocationList: formattedData,
                    loadingLocationData: false,
                })
            } else {
                this.setState({
                    loadingLocationData: false,
                })
            }
        }
    }

    // API CALL TO GET get resource status List 
    getLibraryResourceStatus = async () => {
        this.setState({
            loadingResourceStatusData: true,
        })
        let requestData = {
            "iid": config.institute_id,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryResourceStatus',
            requestData,
            "/api/library/libraryResourceStatus.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getLibraryResourceStatus();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetResourceStatusList: apiResult.data,
                    loadingResourceStatusData: false,
                })
            } else {
                this.setState({
                    loadingResourceStatusData: false,
                })
            }
        }
    }

    // filtered list
    GetFilteredLibraryResourceListForTitleReport = async () => {
        this.setState({
            resourceListLoading: true
        });

        let invoiceNumberArray = [];
        let accessionSeriesIdArray = [];
        let departmentIdArray = [];
        let categoryIdArray = [];
        let locationIdArray = [];
        let typeNameArray = [];


        this.state.searchByAccessionSeries?.map((item) => {
            accessionSeriesIdArray.push(item.value)
        })

        this.state.searchByDepartment?.map((item) => {
            departmentIdArray.push(item.value)
        })

        this.state.searchByResourceCategory?.map((item) => {
            categoryIdArray.push(item.value)
        })

        this.state.searchByLocation?.map((item) => {
            locationIdArray.push(item.value)
        })

        this.state.searchByResourceType?.map((item) => {
            typeNameArray.push(item.value)
        })

        this.state.searchByInvoiceNumber?.map((item) => {
            invoiceNumberArray.push(item.value)
        })



        let searchTitleValue = this.state.searchByTitle || "";
        let searchAuthorValue = this.state.searchByAuthor || "";
        let searchAccessionNumberValue = this.state.searchByAccessionNumber || "";
        let searchInvoiceNumberValue = invoiceNumberArray;
        let searchAccessionSeriesValue = accessionSeriesIdArray;
        let searchDepartmentValue = departmentIdArray;
        let searchCategoryValue = categoryIdArray;
        let searchLocationValue = locationIdArray;
        let searchTypeValue = typeNameArray;
        let searchStatusValue = Object.values(this.state.searchByResourceStatus)[0];


        let filterParameter = {
            "searchTitle": searchTitleValue,
            "searchAuthor": searchAuthorValue,
            "searchAccessionNumber": searchAccessionNumberValue,
            "resource_status": searchStatusValue,
            "fromDate": this.state.billFromDate,
            "toDate": this.state.billToDate,
            "searchinvoice": searchInvoiceNumberValue,
            "searchseries": searchAccessionSeriesValue,
            "streams": searchDepartmentValue,
            "searchresourcecategory": searchCategoryValue,
            "searchlocation": searchLocationValue,
            "searchType": searchTypeValue,
            ...(this.state.isDonated ? { "resource_donation_status": "donated" } : {}) // Conditionally add the "resource_donation_status" field
        };


        let requestData = {
            iid: config.institute_id,
            pageIndex: this.state.pageIndex,
            limitPerPage: this.state.limit,
            filterParameter: filterParameter,
            OnlyParentResources: "true",
            start_date: this.state.billFromDate,
            end_date: this.state.billToDate
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "GetFilteredLibraryResourceListForTitleReport",
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetFilteredLibraryResourceListForTitleReport();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                // Use reduce to accumulate totals
                if (apiResult.success == 'true') {
                    // Use reduce to accumulate totals
                    const totals = Object.values(apiResult.data).reduce((accumulator, resource) => {
                        const keyNoOfCopies = resource.copiesdetails || 0;
                        const keyPrice = resource.price || 0;

                        // Accumulate totals
                        accumulator.totalPrice += parseInt(keyPrice);
                        accumulator.totalNoOfCopies += (parseInt(keyNoOfCopies));
                        return accumulator;
                    }, {
                        totalPrice: 0,
                        totalNoOfCopies: 0,
                    });

                    this.setState({
                        resourceList: apiResult.data,
                        totalResourceListItems: apiResult?.resource_count,
                        priceTotalCount: totals.totalPrice,
                        noOfCopiesTotalCount: totals.totalNoOfCopies,
                        resourceListLoading: false
                    });
                } else {
                    this.setState({
                        resourceList: {},
                        totalResourceListItems: 0,
                        priceTotalCount: 0,
                        noOfCopiesTotalCount: 0,
                        resourceListLoading: false
                    });
                }
            }
        }
    };

    // filter title on change
    handleTitleChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByTitle: event.target.value });
    };
    handleResourceTitleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceListForTitleReport();
        }
    };

    // filter author on change
    handleFilterAuthorChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByAuthor: event.target.value });
    };
    handleResourceAuthorKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceListForTitleReport();
        }
    };

    // filter Accession Number on change
    handleFilterAccessionNoChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByAccessionNumber: event.target.value });
    };
    handleResourceAccessionNoKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceListForTitleReport();
        }
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        if (this.state.searchByTitle !== '' || this.state.searchByAuthor !== '' || this.state.searchByAccessionNumber !== '' || this.state.searchByInvoiceNumber.length !== 0 || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByLocation.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.isDonated != false || this.state.searchByResourceStatus.value !== 'All') {
            this.setState({
                pageIndex: 1, limit: event.target.value, searchByTitle: this.state.searchByTitle, searchByAuthor: this.state.searchByAuthor, searchByAccessionNumber: this.state.searchByAccessionNumber, searchByInvoiceNumber: this.state.searchByInvoiceNumber, searchByAccessionSeries: this.state.searchByAccessionSeries, searchByDepartment: this.state.searchByDepartment, searchByResourceCategory: this.state.searchByResourceCategory, searchByLocation: this.state.searchByLocation, searchByResourceType: this.state.searchByResourceType, isDonated: this.state.isDonated, searchByResourceStatus: this.state.searchByResourceStatus
            }, () => {
                this.GetFilteredLibraryResourceListForTitleReport();
            });
        } else {
            this.setState({ pageIndex: 1, limit: event.target.value }, () => {
                this.GetLibraryResourceListForTitleReport();
            });
        }
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        if (this.state.searchByTitle !== '' || this.state.searchByAuthor !== '' || this.state.searchByAccessionNumber !== '' || this.state.searchByInvoiceNumber.length !== 0 || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByLocation.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.isDonated != false || this.state.searchByResourceStatus.value !== 'All') {
            this.setState({ pageIndex: pageNumber, searchByTitle: this.state.searchByTitle, searchByAuthor: this.state.searchByAuthor, searchByAccessionNumber: this.state.searchByAccessionNumber, searchByInvoiceNumber: this.state.searchByInvoiceNumber, searchByAccessionSeries: this.state.searchByAccessionSeries, searchByDepartment: this.state.searchByDepartment, searchByResourceCategory: this.state.searchByResourceCategory, searchByLocation: this.state.searchByLocation, searchByResourceType: this.state.searchByResourceType, isDonated: this.state.isDonated, searchByResourceStatus: this.state.searchByResourceStatus }, () => {
                this.GetFilteredLibraryResourceListForTitleReport();
            });
        } else {
            this.setState({ pageIndex: pageNumber }, () => {
                this.GetLibraryResourceListForTitleReport();
            });
        }
    };

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            searchByTitle: '', searchByAuthor: '', searchByAccessionNumber: '', searchByInvoiceNumber: [], searchByAccessionSeries: [], searchByDepartment: [], searchByResourceCategory: [], searchByLocation: [], searchByResourceType: [], searchByResourceStatus: {
                "value": "All",
                "label": "All"
            }, isDonated: false, billFromDate: '', billToDate: '',
            limit: "10", pageIndex: 1
        }
            , () => {
                this.GetLibraryResourceListForTitleReport();
            }
        )
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];
        let filterResourceTitle = this.state.searchByTitle
        let filterResourceAuthor = this.state.searchByAuthor
        let filterAccessionNumber = this.state.searchByAccessionNumber
        let filterInvoiceNumber = this.state.searchByInvoiceNumber
        let filterAccessionSeries = this.state.searchByAccessionSeries
        let filterDepartment = this.state.searchByDepartment
        let filterResourceCategory = this.state.searchByResourceCategory
        let filterLocation = this.state.searchByLocation
        let filterResourceType = this.state.searchByResourceType
        let filterResourceStatus = this.state.searchByResourceStatus
        let filterIsDonated = this.state.isDonated
        let filterBillFromDate = this.state.billFromDate
        let filterBillToDate = this.state.billToDate

        if (filterResourceTitle) {
            FilterArray.push(`Resource Title - ${filterResourceTitle}`)
        }
        if (filterResourceAuthor) {
            FilterArray.push(`Resource Author - ${filterResourceAuthor}`)
        }
        if (filterAccessionNumber) {
            FilterArray.push(`Accession Number - ${filterAccessionNumber}`)
        }
        if (this.state.searchByInvoiceNumber && filterInvoiceNumber.length > 0) {
            FilterArray.push(`Invoice Number - ${filterInvoiceNumber?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByAccessionSeries && filterAccessionSeries.length > 0) {
            FilterArray.push(`Accession Series - ${filterAccessionSeries?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByDepartment && filterDepartment.length > 0) {
            FilterArray.push(`Department - ${filterDepartment?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceCategory && filterResourceCategory.length > 0) {
            FilterArray.push(`Resource Category - ${filterResourceCategory?.map(item => item.label).join(", ")}`)
        }
        if (this.state.filterLocation && filterLocation.length > 0) {
            FilterArray.push(`Location - ${filterLocation?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceType && filterResourceType.length > 0) {
            FilterArray.push(`Resource Type - ${filterResourceType?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceStatus && filterResourceStatus.length > 0) {
            FilterArray.push(`Resource Status - ${filterResourceStatus?.map(item => item.label).join(", ")}`)
        }
        if (filterIsDonated) {
            FilterArray.push(`Donated Resources - ${this.state.isDonated ? 'Donated' : 'Not-Donated'}`)
        }
        if (filterBillFromDate) {
            FilterArray.push(`Bill From Date - ${filterBillFromDate}`)
        }
        if (filterBillToDate) {
            FilterArray.push(`Bill To Date - ${filterBillToDate}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllResourceTitleReport" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="16" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="16" style={{ textAlign: 'center' }}>
                                Resource Title
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="16" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="16" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="16" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Title</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>Author</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Resource Volume</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>Resource Edition</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Resource Language</th>}
                        {this.state.exportItemVisibilityForRows[5].isVisible && <th>Publisher</th>}
                        {this.state.exportItemVisibilityForRows[6].isVisible && <th>Number of Copies</th>}
                        {this.state.exportItemVisibilityForRows[7].isVisible && <th>Number of Pages</th>}
                        {this.state.exportItemVisibilityForRows[8].isVisible && <th>Number of Preliminary Pages</th>}
                        {this.state.exportItemVisibilityForRows[9].isVisible && <th>Year of Publication</th>}
                        {this.state.exportItemVisibilityForRows[10].isVisible && <th>Resource Type</th>}
                        {this.state.exportItemVisibilityForRows[11].isVisible && <th>Translated</th>}
                        {this.state.exportItemVisibilityForRows[12].isVisible && <th>Resource Condition</th>}
                        {this.state.exportItemVisibilityForRows[13].isVisible && <th>Price</th>}
                        {this.state.exportItemVisibilityForRows[14].isVisible && <th>Donated</th>}
                        {this.state.exportItemVisibilityForRows[15].isVisible && <th>Resource Status</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="16">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((resource, index) => {
                                    return (

                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.title || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.author || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.volume || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{resource?.edition || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{resource?.resource_lang || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[5].isVisible && <td>{resource?.publisherName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[6].isVisible && <td>{resource?.copiesdetails || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[7].isVisible && <td>{resource?.number_of_pages || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[8].isVisible && <td>{resource?.preliminary_pages || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[9].isVisible && <td>{resource?.yearOfPublication || ""}</td>}

                                            {this.state.exportItemVisibilityForRows[10].isVisible && <td>{resource?.resource_type || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[11].isVisible && <td>{resource?.transalated || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[12].isVisible && <td>{resource?.resource_condition || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[13].isVisible && <td>{resource?.price || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[14].isVisible && <td>{resource?.donated || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[15].isVisible && <td>{resource?.resource_status || ""}</td>}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="16">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalResourceListItems } = this.state;
        const totalPages = Math.ceil(totalResourceListItems / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let jsonResponse;

            let invoiceNumberArray = [];
            let accessionSeriesIdArray = [];
            let departmentIdArray = [];
            let categoryIdArray = [];
            let locationIdArray = [];
            let typeNameArray = [];


            this.state.searchByAccessionSeries?.map((item) => {
                accessionSeriesIdArray.push(item.value)
            })

            this.state.searchByDepartment?.map((item) => {
                departmentIdArray.push(item.value)
            })

            this.state.searchByResourceCategory?.map((item) => {
                categoryIdArray.push(item.value)
            })

            this.state.searchByLocation?.map((item) => {
                locationIdArray.push(item.value)
            })

            this.state.searchByResourceType?.map((item) => {
                typeNameArray.push(item.value)
            })

            this.state.searchByInvoiceNumber?.map((item) => {
                invoiceNumberArray.push(item.value)
            })

            let searchTitleValue = this.state.searchByTitle || "";
            let searchAuthorValue = this.state.searchByAuthor || "";
            let searchAccessionNumberValue = this.state.searchByAccessionNumber || "";
            let searchInvoiceNumberValue = invoiceNumberArray;
            let searchAccessionSeriesValue = accessionSeriesIdArray;
            let searchDepartmentValue = departmentIdArray;
            let searchCategoryValue = categoryIdArray;
            let searchLocationValue = locationIdArray;
            let searchTypeValue = typeNameArray;
            let searchStatusValue = Object.values(this.state.searchByResourceStatus)[0];
            let searchBillFromDateValue = this.state.billFromDate || "";
            let searchBillToDateValue = this.state.billToDate || "";

            let filterParameter = {
                "searchTitle": searchTitleValue,
                "searchAccessionNumber": searchAccessionNumberValue,
                "searchAuthor": searchAuthorValue,
                "resource_status": searchStatusValue,
                "searchinvoice": searchInvoiceNumberValue,
                "searchseries": searchAccessionSeriesValue,
                "streams": searchDepartmentValue,
                "searchresourcecategory": searchCategoryValue,
                "searchlocation": searchLocationValue,
                "searchType": searchTypeValue,
                "fromDate": searchBillFromDateValue,
                "toDate": searchBillToDateValue,
                ...(this.state.isDonated ? { "resource_donation_status": "donated" } : {}) // Conditionally add the "resource_donation_status" field
            };


            let requestData = {
                'iid': config.institute_id,
                'pageIndex': pageIndex,
                'limitPerPage': 50,
                'resource_status': 'all',
                'OnlyParentResources': 'true'
            };

            let requestDataFilter = {
                'iid': config.institute_id,
                'pageIndex': pageIndex,
                'limitPerPage': 50,
                'filterParameter': filterParameter,
                'OnlyParentResources': "true",
                'start_date': searchBillFromDateValue,
                'end_date': searchBillToDateValue
            }

            {
                (this.state.searchByTitle !== '' || this.state.searchByAuthor !== '' || this.state.searchByAccessionNumber !== '' || this.state.searchByInvoiceNumber.length !== 0 || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByLocation.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.isDonated != false || this.state.searchByResourceStatus.value !== 'All') ?
                    jsonResponse = await LibraryApiCall.makeApiCall(
                        'GetFilteredLibraryResourceListForTitleReport',
                        requestDataFilter,
                        '/api/library/instructor.php'
                    ) : jsonResponse = await LibraryApiCall.makeApiCall(
                        'GetLibraryResourceListForTitleReport',
                        requestData,
                        '/api/library/instructor.php'
                    )

            }

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;
                    let Data = [];
                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];

                    sortedResponseArrayFromApi.map((uid) => {
                        Data.push(apiResult[uid]);
                    });

                    // Concatenate new data and update state
                    this.setState((prevState) => ({
                        allReportData: [
                            ...prevState.allReportData,
                            ...Data,
                        ],
                    }), () => {
                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });

                    // Concatenate new data and update state
                    // this.setState({
                    //     allReportData: { ...allReportData, ...apiResult },
                    //     allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                    //     totalRecords: jsonResponse.APIResult.resource_count,
                    // }, () => {

                    //     // Fetch the next page recursively
                    //     this.methodToExportReportData(pageIndex);
                    // });
                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    // METHOD TO ADVANCE FILTER
    returnAdvanceFilterModelData = () => {
        return (
            // <div className={this.state.advanceFilterModal ? "modal fade show" : "modal fade"} id="modalContainer">
            //     <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50VW' }}>
            <div style={{ display: this.state.advanceFilterModal ? 'flex' : 'none' }} id="reportsSideMenu">
                <div id="reportDataContainer">
                    {/* <div className="modal-content modalBulkContent"> */}
                    {/* Modal Header */}
                    <div className="modal-header" style={{ padding: '20px 25px', borderBottom: '2px solid #e0e0e0' }}>
                        <h6 className="modal-title">
                            {/* <img src={advanceFilter} alt="Advanced Filter" style={{ marginRight: '10px', color: '#fff' }} /> */}
                            <FontAwesomeIcon size='sm' icon={["fa", "filter"]} style={{ marginRight: '10px' }} />
                            Advanced Filter
                        </h6>
                        <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => { this.setState({ advanceFilterModal: false }) }} style={{ cursor: "pointer" }} />
                    </div>

                    {/* Modal Content */}
                    {/* className="custom-form-body" style={{ padding: '10px', overflowY: 'auto', maxHeight: '60vh' }} */}
                    <div className='col-md-12 pt-2 pb-3'>
                        {/* Form Group: Accession Series and department*/}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Accession Series</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={this.state.accessionSeriesList}
                                        value={this.state.searchByAccessionSeries}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                searchByAccessionSeries: event || [], // Handle empty selection
                                            });
                                        }}
                                        placeholder="Select Accession Series"
                                        isLoading={this.state.loadingAccessionSeries} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingAccessionSeries ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Department</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={Object.values(this.state.GetStreamList).map(item => ({
                                            value: item.sid,
                                            label: item.name,
                                        }))}
                                        value={this.state.searchByDepartment}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            // if (event.length > 5) {
                                            //     toast.warn('You can only select up to 5 department', {
                                            //         position: "top-right",
                                            //         autoClose: 2000,
                                            //         hideProgressBar: false,
                                            //         closeOnClick: true,
                                            //         pauseOnHover: true,
                                            //         draggable: true,
                                            //         progress: undefined,
                                            //     });
                                            // } else {
                                            this.setState({
                                                searchByDepartment: event || [], // Handle empty selection
                                            });
                                            // }
                                        }}
                                        placeholder="Select Department"
                                        isLoading={this.state.loadingStreamData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingStreamData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Form Group: Category and Location */}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Resource Category</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={Object.values(this.state.GetResourceCategoryList).flatMap(item => {
                                            // Start with the category itself
                                            const categoryOption = {
                                                value: item.value,
                                                label: item.name,
                                                isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
                                            };

                                            // If the category has subcategories, add those as well
                                            const subCategoryOptions = item.subCategories.map(subCategory => ({
                                                value: subCategory.subCategoryId,
                                                label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                                                isDisabled: false, // Subcategory is always enabled
                                            }));

                                            // Return the category option followed by the subcategory options
                                            return [categoryOption, ...subCategoryOptions];
                                        })}
                                        value={this.state.searchByResourceCategory}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            // if (event.length > 5) {
                                            //     toast.warn('You can only select up to 5 resource category', {
                                            //         position: "top-right",
                                            //         autoClose: 2000,
                                            //         hideProgressBar: false,
                                            //         closeOnClick: true,
                                            //         pauseOnHover: true,
                                            //         draggable: true,
                                            //         progress: undefined,
                                            //     });
                                            // } else {
                                            this.setState({
                                                searchByResourceCategory: event || [], // Handle empty selection
                                            });
                                            // }
                                        }}
                                        placeholder="Select Resource Category"
                                        isLoading={this.state.loadingResourceCategoryData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingResourceCategoryData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Location</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={Object.values(this.state.GetLocationList)?.flatMap((data) => {
                                            // Start with the parent location itself
                                            const locationOption = {
                                                value: data.value,
                                                label: data.name,
                                                isDisabled: data.sublocations && data.sublocations.length > 0, // Disable the parent if it has sublocations
                                            };

                                            // If the location has sublocations, add them as well
                                            const subLocationOptions = data.sublocations?.map((sublocation) => ({
                                                value: sublocation.sublocationId,
                                                label: `${data.name} => ${sublocation.sublocationName}`, // Parent location followed by sublocation name
                                                isDisabled: false, // Subcategory is always enabled
                                            }));

                                            // Return the location option followed by the sublocation options
                                            return [locationOption, ...subLocationOptions];
                                        })}
                                        value={this.state.searchByLocation}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            // if (event.length > 5) {
                                            //     toast.warn('You can only select up to 5 location', {
                                            //         position: "top-right",
                                            //         autoClose: 2000,
                                            //         hideProgressBar: false,
                                            //         closeOnClick: true,
                                            //         pauseOnHover: true,
                                            //         draggable: true,
                                            //         progress: undefined,
                                            //     });
                                            // } else {
                                            this.setState({
                                                searchByLocation: event || [], // Handle empty selection
                                            });
                                            // }
                                        }}
                                        placeholder="Select Location"
                                        isLoading={this.state.loadingResourceCategoryData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingResourceCategoryData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Form Group: Resource Type and  Resource Status*/}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Resource Type</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={resourceTypeData.map((item) => ({
                                            label: item,
                                            value: item
                                        }))}
                                        value={this.state.searchByResourceType}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                searchByResourceType: event || [], // Handle empty selection
                                            });
                                        }}
                                        placeholder="Select Resource Type"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Resource Status</label>
                                <Select
                                    options={Object.values(this.state.GetResourceStatusList).map(item => ({
                                        value: item.status,
                                        label: item.status,
                                    }))}
                                    value={this.state.searchByResourceStatus}
                                    onChange={(event) => {
                                        this.setState({
                                            searchByResourceStatus: event || [], // Handle empty selection
                                        });
                                    }}
                                    placeholder="Select Resource Status"
                                    isLoading={this.state.loadingResourceStatusData} // Show loading spinner while fetching
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            width: '100%',
                                            minHeight: 42, // Minimum height for the control area
                                            height: 'auto', // Allow control to grow dynamically
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                        }),
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            fontSize: '12px',
                                            fontWeight: 400,
                                        }),
                                        option: (base, state) => ({
                                            ...base,
                                            fontSize: '12px',
                                            fontWeight: 400,
                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                            color: state.isSelected ? '#333' : '#555',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '12px',
                                            fontWeight: '400',
                                        }),
                                    }}
                                    menuPortalTarget={document.body}
                                    noOptionsMessage={() => (this.state.loadingResourceStatusData ? "Loading..." : "No options found")}
                                />
                            </div>
                        </div>

                        {/* Form Group: Bill from date and Bill to date*/}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Bill From Date</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                        placeholder="Select Bill From Date"
                                        value={this.state.billFromDate}
                                        onChange={(event) => {
                                            this.setState({
                                                billFromDate: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Bill To Date</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                        placeholder="Select Bill To Date"
                                        value={this.state.billToDate}
                                        onChange={(event) => {
                                            this.setState({
                                                billToDate: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Form Group: Only Donated Resources and not issued resource */}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body5" color='#454E52'>
                                    <input
                                        type="checkbox"
                                        checked={this.state.isDonated}
                                        onChange={() => {
                                            // Toggle the value of isDonated
                                            this.setState(prevState => ({
                                                pageIndex: 1,  // Resetting pageIndex to 1
                                                limit: "10",    // Resetting limit to 10
                                                isDonated: !prevState.isDonated // Toggle the isDonated state
                                            }))
                                        }}
                                        style={{ marginRight: '10px' }}  // Adding space between the checkbox and text
                                    />
                                    Donated Resources
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="modal-footer" style={{ padding: '20px 25px' }}>
                        <button
                            className="btn custom-btn"
                            style={{ fontSize: '14px', borderRadius: '7px' }}
                            // borderColor: '#0465AC !important'
                            onClick={() => {

                                this.setState({
                                    advanceFilterModal: false, searchByTitle: '', searchByAuthor: '', searchByAccessionNumber: '', searchByInvoiceNumber: [], searchByAccessionSeries: [], searchByDepartment: [], searchByResourceCategory: [], searchByLocation: [], searchByResourceType: [], searchByResourceStatus: {
                                        "value": "All",
                                        "label": "All"
                                    }, isDonated: false, billFromDate: '', billToDate: '',
                                    limit: "10", pageIndex: 1
                                }, () => {
                                    this.GetLibraryResourceListForTitleReport();
                                    this.apiCallToGetAccessionSeries(); // accession series
                                    this.GetLibraryLocationList();  // location list
                                    this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
                                    this.getLibraryInvoiceListDataStatus();  // invoice data
                                    this.apiCallToGetInstituteStreamList(); // stream (department)
                                })
                            }}
                        >
                            Clear
                        </button>
                        <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => {
                            this.setState({ advanceFilterModal: false }, () => {
                                this.GetFilteredLibraryResourceListForTitleReport();
                            })
                        }}>
                            Apply
                        </button>
                    </div>
                    {/* </div> */}
                </div>
            </div >
        );
    }

    render() {
        // display applied filters while exporting data
        let FilterArray = [];
        let filterResourceTitle = this.state.searchByTitle
        let filterResourceAuthor = this.state.searchByAuthor
        let filterAccessionNumber = this.state.searchByAccessionNumber
        let filterInvoiceNumber = this.state.searchByInvoiceNumber
        let filterAccessionSeries = this.state.searchByAccessionSeries
        let filterDepartment = this.state.searchByDepartment
        let filterResourceCategory = this.state.searchByResourceCategory
        let filterLocation = this.state.searchByLocation
        let filterResourceType = this.state.searchByResourceType
        let filterResourceStatus = this.state.searchByResourceStatus
        let filterIsDonated = this.state.isDonated
        let filterBillFromDate = this.state.billFromDate
        let filterBillToDate = this.state.billToDate

        if (filterResourceTitle) {
            FilterArray.push(`Resource Title - ${filterResourceTitle}`)
        }
        if (filterResourceAuthor) {
            FilterArray.push(`Resource Author - ${filterResourceAuthor}`)
        }
        if (filterAccessionNumber) {
            FilterArray.push(`Accession Number - ${filterAccessionNumber}`)
        }
        if (this.state.searchByInvoiceNumber && filterInvoiceNumber.length > 0) {
            FilterArray.push(`Invoice Number - ${filterInvoiceNumber?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByAccessionSeries && filterAccessionSeries.length > 0) {
            FilterArray.push(`Accession Series - ${filterAccessionSeries?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByDepartment && filterDepartment.length > 0) {
            FilterArray.push(`Department - ${filterDepartment?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceCategory && filterResourceCategory.length > 0) {
            FilterArray.push(`Resource Category - ${filterResourceCategory?.map(item => item.label).join(", ")}`)
        }
        if (this.state.filterLocation && filterLocation.length > 0) {
            FilterArray.push(`Location - ${filterLocation?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceType && filterResourceType.length > 0) {
            FilterArray.push(`Resource Type - ${filterResourceType?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceStatus && filterResourceStatus.length > 0) {
            FilterArray.push(`Resource Status - ${filterResourceStatus?.map(item => item.label).join(", ")}`)
        }
        if (filterIsDonated) {
            FilterArray.push(`Donated Resources - ${this.state.isDonated ? 'Donated' : 'Not-Donated'}`)
        }
        if (filterBillFromDate) {
            FilterArray.push(`Bill From Date - ${filterBillFromDate}`)
        }
        if (filterBillToDate) {
            FilterArray.push(`Bill To Date - ${filterBillToDate}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        <div>
                            {/* header */}
                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                <div className="d-flex col-md-12 px-0">
                                    <div className="col-md-10 d-flex justify-content-start align-items-center p-0">
                                        {/* action button - filter */}
                                        <div className="d-flex">
                                            <div>
                                                {/* <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF' }}> */}
                                                {/* filter data form*/}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                        {/* Based On Search by title */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Resource Title</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <img
                                                                    src={searchPng}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: '10px',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        color: '#ccc',
                                                                        backgroundColor: 'white',
                                                                        width: '15px',
                                                                        height: '15px',
                                                                        zIndex: 1,
                                                                    }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control formControlAutoTask"
                                                                    id="searchByTitleFilter"
                                                                    placeholder="Search by Title"
                                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                                                    value={this.state.searchByTitle} // Bind value to state
                                                                    onChange={this.handleTitleChange} // Handle input changes
                                                                    onKeyPress={this.handleResourceTitleKeyPress} // Trigger API call on Enter
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On Search by author */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Author</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <img
                                                                    src={searchPng}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: '10px',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        color: '#ccc',
                                                                        backgroundColor: 'white',
                                                                        width: '15px',
                                                                        height: '15px',
                                                                        zIndex: 1,
                                                                    }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control formControlAutoTask"
                                                                    id="searchByAuthorFilter"
                                                                    placeholder="Search by Author"
                                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                                                    value={this.state.searchByAuthor} // Bind value to state
                                                                    onChange={this.handleFilterAuthorChange} // Handle input changes
                                                                    onKeyPress={this.handleResourceAuthorKeyPress} // Trigger API call on Enter
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based on accession series */}
                                                        {/* <div className="mb-2 p-1">
                                                        <label className="vm_custom_body3" color='#454E52'>Accession Series</label>
                                                        <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                            <Select
                                                                isMulti
                                                                options={this.state.accessionSeriesList}
                                                                value={this.state.searchByAccessionSeries}
                                                                className="basic-multi-select-filter"
                                                                onChange={(event) => {
                                                                    this.setState({
                                                                        pageIndex: 1, limit: "10",
                                                                        searchByAccessionSeries: event || [],
                                                                    }, () => this.GetFilteredLibraryResourceList());
                                                                }}
                                                                placeholder="Select Accession Series"
                                                                isLoading={this.state.loadingAccessionSeries}
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        width: '100%',
                                                                        minHeight: 42,
                                                                        height: 'auto',
                                                                    }),
                                                                    multiValue: (base) => ({
                                                                        ...base,
                                                                        backgroundColor: 'none',
                                                                        borderRadius: '5px',
                                                                        border: '1px solid #c4c5c5',
                                                                        fontSize: '12px',
                                                                        fontWeight: '400',
                                                                        color: '#808080',
                                                                        display: 'inline-flex',
                                                                        margin: '2px',
                                                                        whiteSpace: 'nowrap',
                                                                    }),
                                                                    multiValueContainer: (base) => ({
                                                                        ...base,
                                                                        display: 'flex',
                                                                        flexWrap: 'wrap',
                                                                        overflowX: 'auto',
                                                                        minHeight: 42,
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    placeholder: (base) => ({
                                                                        ...base,
                                                                        fontSize: '12px',
                                                                        fontWeight: '400',
                                                                    }),
                                                                    option: (base, state) => ({
                                                                        ...base,
                                                                        fontSize: '12px',
                                                                        fontWeight: '400',
                                                                        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                        color: state.isSelected ? '#333' : '#555',
                                                                    }),
                                                                }}
                                                                menuPortalTarget={document.body}
                                                                noOptionsMessage={() => (this.state.loadingAccessionSeries ? "Loading..." : "No options found")}
                                                            />
                                                        </div>
                                                    </div> */}

                                                        {/* Based On Accession number */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Accession Number</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <img
                                                                    src={searchPng}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: '10px',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        color: '#ccc',
                                                                        backgroundColor: 'white',
                                                                        width: '15px',
                                                                        height: '15px',
                                                                        zIndex: 1,
                                                                    }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control formControlAutoTask"
                                                                    id="searchByAccessionNoFilter"
                                                                    placeholder="Accession Number"
                                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                                                    value={this.state.searchByAccessionNumber}
                                                                    onChange={this.handleFilterAccessionNoChange} // Handle input changes
                                                                    onKeyPress={this.handleResourceAccessionNoKeyPress} // Trigger API call on Enter
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On Invoice number */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Invoice Number</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <Select
                                                                    isMulti
                                                                    options={this.state.GetInvoiceDataList}
                                                                    value={this.state.searchByInvoiceNumber}
                                                                    className="basic-multi-select-filter"
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            searchByInvoiceNumber: event || [], // Handle empty selection
                                                                        }, () => this.GetFilteredLibraryResourceListForTitleReport());
                                                                    }}
                                                                    placeholder="Select Invoice Number"
                                                                    isLoading={this.state.loadingInvoiceData} // Show loading spinner while fetching
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            width: '100%',
                                                                            minHeight: 42, // Minimum height for the control area
                                                                            height: 'auto', // Allow control to grow dynamically
                                                                        }),
                                                                        multiValue: (base) => ({
                                                                            ...base,
                                                                            backgroundColor: 'none',
                                                                            borderRadius: '5px',
                                                                            border: '1px solid #c4c5c5',
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                            color: '#808080',
                                                                            display: 'inline-flex',
                                                                            margin: '2px',
                                                                            whiteSpace: 'nowrap',
                                                                        }),
                                                                        multiValueContainer: (base) => ({
                                                                            ...base,
                                                                            display: 'flex',
                                                                            flexWrap: 'wrap',
                                                                            overflowX: 'auto', // Horizontal scroll when values overflow
                                                                            minHeight: 42, // Ensure consistent height when values are selected
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                        }),
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? '#333' : '#555',
                                                                        }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                    noOptionsMessage={() => (this.state.loadingInvoiceData ? "Loading..." : "No options found")}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Press "Enter" to get Resource Title filter result.</p>
                                                {/* </div> */}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2 d-flex justify-content-end align-items-center p-0">
                                        <div className="d-flex ml-2" title="Advance Filter">
                                            <button className="btn outline-button" style={{ borderRadius: '5px', boxShadow: 'none' }} onClick={() => {
                                                this.setState({
                                                    advanceFilterModal: true,
                                                })
                                            }}> <style type="text/css" media="print">
                                                    {"@page { size: auto; }"}
                                                </style>
                                                <FontAwesomeIcon size='lg' icon={faSlidersH} style={{ cursor: "pointer", color: '#0465AC' }} />
                                            </button>
                                        </div>

                                        {Object.keys(this.state.resourceList).length == 0 ? null :
                                            <>
                                                <div className="d-flex">
                                                    {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                                </div>

                                                {/* 1 action button - export data */}
                                                <div className="d-flex ml-2" title="Click to Export" >
                                                    <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                        {"@page { size: auto; }"}
                                                    </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                                    {/* 2.1 action button option - export and export all */}
                                                    <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                        <span>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="export"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="resourceTitleReport"
                                                                    filename="ResourceTitleReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export to Excel "
                                                                >
                                                                </ReactHTMLTableToExcel>
                                                            </div>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="exportAll"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="ExportAllResourceTitleReport"   // export all functionality
                                                                    filename="ExportAllResourceTitleReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export All to Excel"
                                                                />
                                                            </div>
                                                            <button
                                                                onClick={this.formatCSVExportData}
                                                                className="dropdown-item"
                                                                title="Click to Export"
                                                                style={{ boxShadow: 'none' }}
                                                            >
                                                                Export
                                                            </button>
                                                            {this.state.isExportAllReportDataFetching ? (
                                                                <p className="dropdown-item">
                                                                    Exporting report . . .&nbsp;
                                                                    <FontAwesomeIcon
                                                                        icon={["fas", "circle-notch"]}
                                                                        className="rotate"
                                                                    />
                                                                </p>
                                                            ) : (
                                                                <button
                                                                    onClick={() => this.setState({ allReportData: [] }, () => {
                                                                        this.methodToExportReportData(0)
                                                                    })}
                                                                    className="dropdown-item"
                                                                    title="Click to Export All"
                                                                    style={{ boxShadow: 'none' }}
                                                                >
                                                                    Export All
                                                                </button>
                                                            )}
                                                        </span>

                                                    </div>

                                                </div>

                                                {/* 2 action button - print */}
                                                <div className="d-flex ml-2" title="Click to Print">
                                                    <span className="print-button">
                                                        <ReactToPrint
                                                            trigger={() => {
                                                                return (
                                                                    <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                        <style type="text/css" media="print">
                                                                            {"@page { size: auto; }"}
                                                                        </style>
                                                                        <span>
                                                                            <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }}
                                                            content={() => this.componentRef}
                                                        />
                                                    </span>
                                                </div>

                                                {/* 3 action button - column visibility */}
                                                <div className="d-flex ml-2" title="Click to Customize Columns">
                                                    {/* <button className="print-button btn outline-button" style={{ borderRadius: '2.77px' }}> <style type="text/css" media="print">
                                        {"@page { size: auto; }"}
                                    </style> */}
                                                    <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />
                                                    {/* </button> */}

                                                    {/* action modal - column visibility*/}
                                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                        <div id='settingDropdown' className='settingDropdown-body'>
                                                            {
                                                                this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                                    return (
                                                                        <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                            <input type="checkbox" checked={columnInfo.isVisible} />
                                                                        </p>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.searchByTitle !== '' || this.state.searchByAuthor !== '' || this.state.searchByAccessionNumber !== '' || this.state.searchByInvoiceNumber.length !== 0 || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByLocation.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.searchByResourceStatus.value !== 'All' || this.state.isDonated !== false || this.state.billFromDate !== '' || this.state.billToDate !== ''
                                ) &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                </div>
                            }
                        </div>

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Resource Title</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="resourceTitleReport">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="16" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="16" style={{ textAlign: 'center' }}>
                                                        Resource Title
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="16" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="16" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="16" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Title</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>Author</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Resource Volume</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>Resource Edition</th>}
                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Resource Language</th>}
                                                {this.state.exportItemVisibilityForRows[5].isVisible && <th>Publisher</th>}
                                                {this.state.exportItemVisibilityForRows[6].isVisible && <th>Number of Copies</th>}
                                                {this.state.exportItemVisibilityForRows[7].isVisible && <th>Number of Pages</th>}
                                                {this.state.exportItemVisibilityForRows[8].isVisible && <th>Number of Preliminary Pages</th>}
                                                {this.state.exportItemVisibilityForRows[9].isVisible && <th>Year of Publication</th>}
                                                {this.state.exportItemVisibilityForRows[10].isVisible && <th>Resource Type</th>}
                                                {this.state.exportItemVisibilityForRows[11].isVisible && <th>Translated</th>}
                                                {this.state.exportItemVisibilityForRows[12].isVisible && <th>Resource Condition</th>}
                                                {this.state.exportItemVisibilityForRows[13].isVisible && <th>Price</th>}
                                                {this.state.exportItemVisibilityForRows[14].isVisible && <th>Donated</th>}
                                                {this.state.exportItemVisibilityForRows[15].isVisible && <th>Resource Status</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.resourceListLoading ?
                                                    <tr>
                                                        <td colSpan="16">
                                                            <ButtonLoader />
                                                        </td>
                                                    </tr>
                                                    :
                                                    Object.keys(this.state.resourceList).length > 0 ?
                                                        (Object.values(this.state.resourceList).map((resource, index) => {
                                                            return (

                                                                <tr key={index}>
                                                                    <td>{
                                                                        this.state.limit === 'all' ? index + 1 :
                                                                            ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                    }</td>
                                                                    {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.title || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.author || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.volume || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[3].isVisible && <td>{resource?.edition || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[4].isVisible && <td>{resource?.resource_lang || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[5].isVisible && <td>{resource?.publisherName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[6].isVisible && <td>{resource?.copiesdetails || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[7].isVisible && <td>{resource?.number_of_pages || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[8].isVisible && <td>{resource?.preliminary_pages || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[9].isVisible && <td>{resource?.yearOfPublication || ""}</td>}

                                                                    {this.state.exportItemVisibilityForRows[10].isVisible && <td>{resource?.resource_type || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[11].isVisible && <td>{resource?.transalated || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[12].isVisible && <td>{resource?.resource_condition || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[13].isVisible && <td>{resource?.price || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[14].isVisible && <td>{resource?.donated || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[15].isVisible && <td>{resource?.resource_status || ""}</td>}
                                                                </tr>
                                                            )
                                                        })) :
                                                        <tr>
                                                            <td colSpan="16">
                                                                No data found.
                                                            </td>
                                                        </tr>
                                            }

                                            {
                                                // display total and grand total count
                                                Object.keys(this.state.resourceList).length > 0 ?
                                                    this.state.resourceListLoading ? null :
                                                        <>
                                                            <tr>
                                                                <td colSpan="1" style={{ textAlign: "right", fontWeight: "bold" }}>Total</td>
                                                                {/* Count titles */}
                                                                {this.state.exportItemVisibilityForRows[0].isVisible && <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                                                    {Object.keys(this.state.resourceList).length}
                                                                </td>}
                                                                <td colSpan="5"></td>
                                                                {/* Sum of number of copies */}
                                                                {this.state.exportItemVisibilityForRows[6].isVisible && <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                                                    {this.state.noOfCopiesTotalCount}
                                                                </td>}
                                                                <td colSpan="6"></td>
                                                                {/* Sum of price */}
                                                                {this.state.exportItemVisibilityForRows[13].isVisible && <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                                                    {this.state.priceTotalCount}
                                                                </td>}
                                                                <td colSpan="16"></td>
                                                            </tr>
                                                        </>
                                                    : null
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* table footer pagination */}
                            {
                                (Object.keys(this.state.resourceList).length > 0 || Object.keys(this.state.resourceList).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id=""
                                                            value={this.state.limit}
                                                            onChange={this.changeShowEntriesControl}
                                                        >
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalResourceListItems}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalResourceListItems || 0}
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        {
                            this.returnAdvanceFilterModelData()
                        }
                    </div >
                </div>
            </div >

        );
    }
}


export default ResourceTitleReport;